<template>
  <div class="cb-loader">
    <div class="cb-loader__bar" :style="backgroundColor"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'loader',
}
</script>